import React from 'react';
import { ContextMenuData } from '../../../types';
import { IconType, IconPathOptions } from '../../../utils/iconPath';
import { ALL_BLESSINGS_MAP } from '../../../gameData';

interface BuildBlessingItemProps {
  blessingName: string;
  viewedBlessing: string | null;
  contextMenu: ContextMenuData | null;
  closeContextMenu: () => void;
  onBlessingListItemClick: (blessingName: string) => void;
  handleContextMenu: (e: React.MouseEvent, target: string, type: ContextMenuData['type'], options?: string[]) => void;
  getIconPath: (type: IconType, name: string, options?: IconPathOptions) => string;
}

export const BuildBlessingItem: React.FC<BuildBlessingItemProps> = ({
  blessingName,
  viewedBlessing,
  contextMenu,
  closeContextMenu,
  onBlessingListItemClick,
  handleContextMenu,
  getIconPath
}) => {
  const blessingData = ALL_BLESSINGS_MAP.get(blessingName);
  // Strictly typed access
  const faeName = blessingData?.fae; 
  // Fallback for icon type
  const blessingType = blessingData?.type;

  const handleClick = (e: React.MouseEvent) => {
      e.stopPropagation();
      if (contextMenu) closeContextMenu();
      else onBlessingListItemClick(blessingName);
  };

  const handleContext = (e: React.MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();
      handleContextMenu(e, blessingName, 'blessing');
  };

  return (
    <div
      id={`blessing-${blessingName}`}
      className={`
        relative flex items-center p-1 rounded border transition-all cursor-pointer h-10 w-full overflow-hidden
        ${viewedBlessing === blessingName 
           ? 'bg-sworn-gold text-black border-sworn-gold shadow-[0_0_10px_theme(colors.sworn-gold)]' 
           : 'bg-slate-900/80 border-slate-700 text-slate-300 hover:bg-slate-800 hover:border-slate-500 hover:text-white'
        }
        ${contextMenu ? 'no-hover' : ''}
      `}
      onClick={handleClick}
      onContextMenu={handleContext}
      role="button"
      tabIndex={0}
    >
      <div className="w-6 h-6 md:w-8 md:h-8 shrink-0 mr-2 bg-slate-950 rounded border border-slate-800 flex items-center justify-center overflow-hidden">
        {faeName ? (
           <img 
               src={getIconPath('blessing', blessingName, { faeLord: faeName, blessingType })} 
               alt="" 
               className="w-full h-full object-cover" 
           />
        ) : (
           <div className="w-3 h-3 md:w-4 md:h-4 bg-slate-600 rounded-full" />
        )}
      </div>
      <span className="text-[10px] md:text-xs font-semibold truncate leading-tight select-none">
        {blessingName}
      </span>
    </div>
  );
};

export default BuildBlessingItem;
